export default __webpack_public_path__ + "static/4-1-branding-33a9e3d68a75d8426ff5fb025d186518.gif";